const colorLuminance = {

	/*
	** change()
	** Way to change a color luminance, darker or lighter
	**
	** Example:
	** colorLuminance.change("#69c", 0);		// returns "#6699cc"
	** colorLuminance.change("6699CC", 0.2);	// "#7ab8f5" - 20% lighter
	** colorLuminance.change("69C", -0.5);	// "#334d66" - 50% darker
	** colorLuminance.change("000", 1);		// "#000000" - true black cannot be made lighter!
	*/
	change: function(hex, lum) {

		// validate hex string
		hex = String(hex).replace(/[^0-9a-f]/gi, '');
		if (hex.length < 6) {
			hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
		}
		lum = lum || 0;

		// convert to decimal and change luminosity
		var rgb = "#", c, i;
		for (i = 0; i < 3; i++) {
			c = parseInt(hex.substr(i*2,2), 16);
			c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
			rgb += ("00"+c).substr(c.length);
		}

		return rgb;
	},

	/* isTooLight() 
	** will return true if the color is too light for white text to be readable on top of this color
	*/
	isTooLight: function(hexcolor){
		if (hexcolor.substr(0,1) === '#'){
			hexcolor = hexcolor.substr(1);
		}
		var r = parseInt(hexcolor.substr(0,2),16);
		var g = parseInt(hexcolor.substr(2,2),16);
		var b = parseInt(hexcolor.substr(4,2),16);
		var yiq = ((r*299)+(g*587)+(b*114))/1000;
		return yiq >= 128;
	}

}

export default colorLuminance;


// WEBPACK FOOTER //
// ./src/components/vendor/colorLuminance.jsx